export default __webpack_public_path__ + "static/media/Imageninicio.76b367dc.jpg";